<template>
  <div>
    <!-- v-resize="updateTableWidth" -->
    <v-divider class="mt-10 mb-4" ref="divider"></v-divider>

    <div class="d-flex align-center">
      <div class="font-weight-bold">
        실행수량(ton) :
        <span class="font-weight-regular">{{
          quantityPlanTotalTon.toLocaleString("ko-KR")
        }}</span>
      </div>

      <MonthFilter
        :yearList="yearList"
        :activeMonths="activeMonths"
        @onUpdateFilter="onUpdateFilter"
      />
    </div>

    <div class="table-grid">
      <div class="table-summary d-flex">
        <div class="default-header border-r">
          <div
            class="header d-flex align-center justify-center"
            style="height: 80px;"
          >
            구분
          </div>
          <div
            class="td-default h-td border-l d-flex align-center justify-center"
          >
            월별 반입량(ton)
          </div>
          <div
            class="td-default h-td border-l d-flex align-center justify-center"
          >
            반입량 누계(ton)
          </div>
        </div>
        <div class="default-header border-r">
          <div
            class="header d-flex align-center justify-center"
            style="height: 80px;"
          >
            총 누계
          </div>
          <div
            class="border-b d-flex align-center justify-center"
            style="height: 80px;"
          >
            {{ totalTon.toLocaleString("ko-KR") }}
          </div>
        </div>
      </div>

      <div
        ref="tableScroll"
        :class="[
          'table-scroll',
          { 'table-scroll--empty': monthCount === 0 },
        ]"
        @scroll="$emit('onHorizontalScroll', $event.target.scrollLeft)"
      >
        <div class="d-flex" :style="{ width: monthContentWidth + 'px' }">
          <div
            v-for="bodyHeader in monthList"
            :key="bodyHeader.year"
            class="year-header"
          >
            <div class="header border-r w-full h-40">
              {{ bodyHeader.year }}년
            </div>

            <div class="d-flex">
              <div
                v-for="month in bodyHeader.monthList"
                :key="month.month"
                :class="{
                  'close-item': month.closeYn === 'Y',
                }"
              >
                <div class="td td-default-bg" :style="{ width: tdWidth }">
                  {{ month.month }}월
                </div>
                <div class="td" :style="{ width: tdWidth }">
                  {{ month.montlyTon.toLocaleString("ko-KR") }}
                </div>
                <div class="td" :style="{ width: tdWidth }">
                  {{ month.totalTon.toLocaleString("ko-KR") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MonthFilter from "./MonthFilter.vue";

export default {
  props: {
    monthList: { Type: Array, require: true },
    storeMonthList: { Type: Array, require: true }, //  초기 목록
    totalTon: { Type: Number, require: true }, // 총 누계
    quantityPlanTotalTon: { Type: Array, require: true }, // 실행수량
    activeMonths: { Type: Array, require: true }, // 활성화된 월
    monthColumnWidth: { type: Number, default: 56 },
  },
  components: {
    MonthFilter,
  },
  data: () => ({
    yearList: [],
    tableWidth: 0,
  }),
  computed: {
    tdWidth() {
      return this.monthColumnWidth + "px";
    },
    monthCount() {
      return this.monthList?.reduce(
        (count, year) => count + year.monthList.length,
        0,
      );
    },
    monthContentWidth() {
      return Math.max(
        this.tableWidth - 224,
        this.monthCount * this.monthColumnWidth,
      );
    },
  },
  watch: {
    storeMonthList: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.yearList = newVal.map((el) => el.year);
        }
      },
    },
  },
  mounted() {
    const observer = new ResizeObserver(() => {
      this.updateTableWidth();
    });
    observer.observe(this.$refs.divider.$el);

    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     console.log("nextTick", this.tableWidth);
    //     this.updateTableWidth();
    //   }, 0);
    // });
  },
  methods: {
    setScrollLeft(scrollLeft) {
      if (this.$refs.tableScroll?.scrollLeft !== scrollLeft) {
        this.$refs.tableScroll.scrollLeft = scrollLeft;
      }
    },
    onUpdateFilter({ yearCheckList, monthCheckList }) {
      let filterList = monthCheckList ? [...monthCheckList] : [];
      if (yearCheckList && yearCheckList?.length) {
        const allMonth = yearCheckList.flatMap((year) =>
          Array.from({ length: 12 }, (_, i) => {
            const month = String(i + 1).padStart(2, "0");
            return `${year}-${month}`;
          })
        );
        filterList = [...filterList, ...allMonth];
      }
      const sorted = filterList.sort((a, b) => (a > b ? 1 : -1));
      this.$emit("onUpdateFilter", sorted);
    },
    /** 테이블 동적 너비 가져오는 함수 */
    updateTableWidth() {
      this.tableWidth = this.$refs.divider.$el.offsetWidth;
      this.$emit("onUpdateTableWidth", this.tableWidth);
    },
  },
};
</script>

<style lang="css" scoped>
* {
  font-size: 14px;
}
.table-grid {
  display: grid;
  grid-template-columns: 224px minmax(0, 1fr);
}
.table-scroll {
  width: 100%;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  scrollbar-color: #c8cdd2 transparent;
  scrollbar-width: thin;
}
.table-scroll--empty {
  overflow-x: hidden;
}
.table-scroll::-webkit-scrollbar {
  height: 8px;
}
.table-scroll::-webkit-scrollbar-track {
  border: 0;
  background: transparent;
  box-shadow: none;
}
.table-scroll::-webkit-scrollbar-thumb {
  border: 2px solid transparent;
  border-radius: 4px;
  background: #c8cdd2;
  background-clip: content-box;
}
.table-summary {
  align-self: start;
  background: #ffffff;
}
.default-header {
  &:first-child {
    width: 164px;
  }
  &:last-child {
    width: 60px;
  }
}
.year-header {
  display: flex;
  flex-direction: column;
}
.header {
  background: #6f6f6f;
  color: white;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  padding: 8px;
}
.w-full {
  width: 100%;
}
.h-40 {
  height: 40px;
}
.border-r {
  border-right: 1px solid #dddddd;
}
.border-l {
  border-left: 1px solid #dddddd;
}
.border-b {
  border-bottom: 1px solid #dddddd;
}
.h-td {
  height: 40px;
}
.td-default {
  background: #f5f4f3;
  color: #222222;
  border-bottom: 1px solid #dddddd;
}
.td {
  /* width: 66px; */
  height: 40px;
  display: flex;
  justify-content: flex-end;
  padding: 0px 8px;
  align-items: center;
  border-right: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}
.td-default-bg {
  background-color: #f5f4f3;
}
.close-item {
  > .td {
    background-color: rgba(255, 64, 64, 0.06);
  }
}
</style>
